module.exports = __webpack_public_path__ + "img/21.11d0f8a3.png";